import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import {
  checkRequired,
  validateEmail,
  validatePhoneNumber,
} from "pages/formTools";
import { Vendor } from "../..";
import { validateSignatory } from "../../helpers/signatoryValidation";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

export const validatePrivacyContact = (data: Vendor): FieldErrorMap => ({
  organizationType: checkRequired(
    ta("fields.organization_type"),
    data.organizationType,
  ),

  primaryContactFirstName: checkRequired(
    ta("fields.primary_first"),
    data.primaryContactFirstName,
  ),

  primaryContactLastName: checkRequired(
    ta("fields.primary_last"),
    data.primaryContactLastName,
  ),

  primaryContactPosition: checkRequired(
    ta("fields.primary_position"),
    data.primaryContactPosition,
  ),

  primaryContactEmail: validateEmail({
    name: ta("fields.primary_email"),
    value: data.primaryContactEmail,
    required: true,
  }),

  primaryContactPhone: validatePhoneNumber({
    name: ta("fields.primary_phone"),
    value: data.primaryContactPhone,
    required: true,
  }),

  ...(data.primaryContactIsSignatory ? {} : validateSignatory(data)),
});
